module.exports = __webpack_public_path__ + "dist/assets/img/M.2c132a4d.svg";